import EmptyIcon from "./PetsEmptyIcon.svelte";
import FilledIcon from "./PetsFilledIcon.svelte";
import HalfIcon from "./PetsHalfIcon.svelte";

export default {
    filled: FilledIcon,
    half: HalfIcon,
    empty: EmptyIcon,
};
